import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { FaAngleLeft } from 'react-icons/fa6';
import { Modal } from 'bootstrap';

import { useDispatch, useSelector } from 'react-redux';
import ProgressSteps from '../../ProgressStep/ProgressSteps';
import CardsProgressSteps from '../../ProgressStep/CardsProgressSteps';
import { changeAccountPassword, changePassword, passwordReset } from '../../../api/auth';
import { refreshUserDetails } from '../../../actions/user';
import { PiEyeSlashThin, PiEyeThin } from 'react-icons/pi';
import { updateUserPassword } from '../../../api/user';


const ResetPin = () => {
    const userDetails = useSelector((state) => state.user.user);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [oldPin, setOldPin] = useState("");
    const [newPin, setNewPin] = useState("");
    const [confirmPin, setConfirmPin] = useState("");
    const [isEdited, setIsEdited] = useState(false);
    const [loading, setLoading] = useState(false);
    const [modalMessage, setModalMessage] = useState("");
    const currentPage = window.location.pathname;
    const isSettingPage = currentPage.includes("user/settings");
    const [passwordType, setPasswordType] = useState("password");
    const [isPasswordReset, setIsPasswordReset] = useState(false);
    const [otp, setOtp] = useState("");
    
    const togglePasswordVisibility = (setter, currentType) => {
        setter(currentType === 'password' ? 'text' : 'password');
    };
    

    const handleInputChange = (setter) => (e) => {
        setter(e.target.value);
        setIsEdited(true);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!newPin || !confirmPin) {
            toast.error("All fields are required!", {className: "custom-toast"});
            return;
        }

        if (newPin !== confirmPin) {
            toast.error("New Password and Confirm Password must match!", {className: "custom-toast"});
            return;
        }
        if (newPin === oldPin) {
            toast.error("New Password cannot be the same as the old Password!", {className: "custom-toast"});
            return;
        }
        if (isPasswordReset && otp.length !== 6) {
            toast.error("OTP must be exactly 6 digits!", {className: "custom-toast"});
            return;
        }
        if (!isPasswordReset && newPin === oldPin) {
            toast.error("New Password cannot be the same as the old PIN!", {className: "custom-toast"});
            return;
        }

        const credentials = {
            ...(isPasswordReset ? 
                { otp, email: userDetails?.email, password: newPin, password_confirmation: confirmPin, } 
                : {current_password: oldPin, new_password: newPin, new_password_confirmation: confirmPin}),
        }
        const userId = userDetails?.id;

        setLoading(true);
        // console.log(credentials);
        

        try {
            const { data } = isPasswordReset ? await changePassword(credentials) : await updateUserPassword(credentials, userId);
            // console.log(data);
            
            refreshUserDetails(dispatch);
            
            setModalMessage("Your password has been successfully changed.");
            toast.success("Password changed successfully!", {
                toastId: "pin-change-success-toast",
                className: "custom-toast",
            });

            const modal = new Modal(document.getElementById('pinChangeModal'));
            modal.show();

            setOldPin("");
            setNewPin("");
            setConfirmPin("");
            setOtp("");
        } catch (error) {
            setModalMessage("Failed to change your Password. Please try again.");
            toast.error(error.response.data.message || "Password change failed!", {
                toastId: "pin-change-fail-toast",
                className: "custom-toast",
            });
            // console.error('Error changing Password:', error);
        } finally {
            setLoading(false);
        }
    };

    const handlePasswordResetRequest = async () => {
        const email = userDetails?.email; 
        setLoading(true);
        try {
            const { data } = await passwordReset(email);
            // console.log(data);
            toast.success(data.message || "Password reset request sent successfully!", {
                toastId: "pin-reset-success-toast",
                className: "custom-toast",
            })
            setIsPasswordReset(true);  
            setOldPin("");
            setNewPin("");
            setConfirmPin("");
            setOtp("");      
        } catch (error) {
            // console.error('Error requesting Password reset:', error);
            toast.error(error.response.data.message.message || "Password reset request failed!", {
                toastId: "pin-reset-fail-toast",
                className: "custom-toast",
            })            
        } finally {
            setLoading(false);
        }
    };

    const handleGoBack = () => {
        if (isSettingPage) {
            navigate(-1);
        } else {
            navigate(`/user/cards/card_option`);
        }
    };

    return (
        <section className="create__card__page card__fund__page">
            {!isSettingPage && (
                <div className="d-flex align-items-center mt-3">
                    <button onClick={handleGoBack} className="btn btn-sm" style={{ color: '#777' }}>
                        <FaAngleLeft size={15} />
                        <span className="ms-1 small mt-1">Back to Card Options</span>
                    </button>
                </div>
            )}

            {/* <section className='mb-2'>
              <CardsProgressSteps currentStep={3} stepLabels={["Verify Email", "OTP", "Set Password", "Success"]} />
            </section> */}

            <section className="create-card_section funding__card__section">
                <div className="container">
                    <form onSubmit={handleSubmit} className="funding__form pin__action__form">
                        <div className="form__card-section mb-5">
                            <div className="mb-4">
                                <label className="form-label">{ isPasswordReset ? "Enter OTP sent to your email" : " Enter old Password" }</label>
                                <div className="input-group">
                                    <input 
                                        type={passwordType} 
                                        className="form-control" 
                                        value={ isPasswordReset ? otp : oldPin } 
                                        onChange={handleInputChange(isPasswordReset ? setOtp : setOldPin)} 
                                    />
                                    <span className='input-group-text' role="button" onClick={() => togglePasswordVisibility(setPasswordType, passwordType)}>
                                        {passwordType === 'password' ? <PiEyeSlashThin color="#0986E6" size={20} /> : <PiEyeThin color="#0986E6" size={20} />}
                                    </span>
                                </div>
                                <span onClick={handlePasswordResetRequest} className='reset__pin forget__password small' role='button' title='click to reset'>Have you forgotten your Password?</span>
                            </div>

                            <div className="mb-4">
                                <label className="form-label">Enter New Password</label>
                                <div className="input-group">
                                    <input 
                                        type={passwordType} 
                                        className="form-control" 
                                        value={newPin} 
                                        onChange={handleInputChange(setNewPin)} 
                                    />
                                    <span className='input-group-text' role="button" onClick={() => togglePasswordVisibility(setPasswordType, passwordType)}>
                                        {passwordType === 'password' ? <PiEyeSlashThin color="#0986E6" size={20} /> : <PiEyeThin color="#0986E6" size={20} />}
                                    </span>
                                </div>
                            </div>

                            <div className="mb-4">
                                <label className="form-label">Confirm New Password</label>
                                <div className="input-group">
                                    <input 
                                        type={passwordType} 
                                        className="form-control" 
                                        value={confirmPin} 
                                        onChange={handleInputChange(setConfirmPin)} 
                                    />
                                    <span className='input-group-text' role="button" onClick={() => togglePasswordVisibility(setPasswordType, passwordType)}>
                                        {passwordType === 'password' ? <PiEyeSlashThin color="#0986E6" size={20} /> : <PiEyeThin color="#0986E6" size={20} />}
                                    </span>
                                </div>
                            </div>
                        </div>

                        {/* Change PIN Button */}
                        <div className="d-flex align-items-center justify-content-center mt-4">
                            <button 
                                type="submit" 
                                className="btn primary__btn w-100" 
                                disabled={!isEdited || !newPin || !confirmPin || loading}
                            >
                                {loading ? (
                                    <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                ) : (
                                    "Change Password"
                                )}
                            </button>
                        </div>
                    </form>
                </div>
            </section>

            {/* Bootstrap Modal */}
            <section className="modal fade" id="pinChangeModal" tabIndex="-1" aria-labelledby="pinChangeModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered" role="document">
                    <div className="modal-content">
                        <div className="d-flex justify-content-end p-3">
                            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body my-2 mx-4 text-center">
                            <h4>{modalMessage.includes("successfully") ? "Password Changed Successfully" : "Error Changing Password"}</h4>
                            <p>{modalMessage}</p>
                            <button className="btn primary__btn__outline mt-5 w-50 mx-auto" data-bs-dismiss="modal" aria-label="Close">
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </section>
        </section>
    );
}

export default ResetPin